// @ts-nocheck
 
 
 
 
 
/* eslint-disable import/order */
 
 
 
/* eslint-disable react/jsx-newline */
 
 
 
 
import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { NotAuthorized } from 'app/components/not-authorized';
import { CardContainer } from 'app/components/shared/card-container';
import  FinancialAccountsTable  from './FinancialAccountTable';
import { trimTrailingSlash, useTypedSelector } from 'helpers';
import { hasWriteAccessToMasterConfigSubSystem } from 'selectors';
import AddFinancialAccounts from './addFinancialAccount';
import EditFinancialAccounts from './updateFinancialAccount';
import ViewFinancialAccounts from './view-FinancialAccount';

const FinancialAccounts: React.FC = () => {
  const match = useRouteMatch();
  const baseURL = trimTrailingSlash(match.url);

  const hasFinancialAccountsAddAccess = useTypedSelector(state =>
    hasWriteAccessToMasterConfigSubSystem(state, 'FinancialAccounts')
  );

  return (
    <CardContainer>
      <Switch>
        <Route path={`${baseURL}/new`}>
          {hasFinancialAccountsAddAccess ? <AddFinancialAccounts/> : <NotAuthorized />}
        </Route>

        <Route path={`${baseURL}/:id/edit`}>
        {hasFinancialAccountsAddAccess ? <EditFinancialAccounts/> : <NotAuthorized />}
        </Route>
        <Route path={`${baseURL}/:id`}>
         <ViewFinancialAccounts/>
        </Route>
        <Route exact path={`${baseURL}`}>
          <FinancialAccountsTable/>
        </Route>
      </Switch>
    </CardContainer>
  );
};

export { FinancialAccounts };
